<template>
    <div class="development">
        <div class="league-layout">
          <league-nav></league-nav>

          <div class="league-development">
            <h3>发展历程</h3>

            <div class="Con-development">
                <p class="development-tit">中国技术创业协会留学人员创业园工作委员会发展历程</p>
                <div class="development-art"
                  v-for="(item ,index) in developmentList"
                  :key="index"
                  >
                  <!-- 去掉的点击进入查看： @click="goDetail('/developmentDetatil',item)" -->
                    <img :src="item.icon" alt="">
                    <div class="deed">
                        <p class="title">{{item.title}}</p>
                        <p class="flex-row">
                            <span class="time" v-if="item.gmtInsert">{{item.gmtInsert.slice(0, 3).join('-')}}</span>
                            <span class="reader">
                                <img src="@/assets/home/contentReader.png" alt="">
                                阅读{{developRederCount[item.id+''] || 0}}
                            </span>
                        </p>
                        <p class="content" v-html="item.detail"></p>
                    </div>
                </div>
            </div>

            <paging :totalPage="totalNum"
              :pageSize="size"
              :CurrentPage="page"
              @curentPage="handleCurrentChange">
            </paging>
          </div>
        </div>
        <return-top></return-top>
    </div>
</template>

<script>
import LeagueNav from '@/components/leagueNav.vue'
import Paging from '@/components/paging.vue'
import ReturnTop from '@/components/returnTop.vue'

export default {
  name: 'development',
  components: {
    LeagueNav,
    Paging,
    ReturnTop
  },
  data () {
    return {
      developRederCount: '',
      developmentList: [],
      page: 1, // 默认页码
      size: 10, // 每页数据条数
      totalNum: 0 // 总条数
    }
  },
  computed: {

  },
  created () {
    this.getDevelopment()
    this.getdevelopRederNum()
  },
  mounted () {
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '11'
  },
  methods: {
    // 获取发展历程阅读量
    async getdevelopRederNum () {
      try {
        const res = await this.$get(this.$url.serve.readerNum, {
          type: '发展历程'
        })
        const { code, msg, data } = res.data
        if (code === 200) {
          this.developRederCount = data
          console.log(this.developRederCount)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    async getDevelopment () {
      try {
        const res = await this.$get(this.$url.league.leagueorDevelopment, {
          page: this.page,
          size: this.size
        })

        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.developmentList = data.records
          this.totalNum = data.total
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 分页功能
    handleCurrentChange (page) {
      this.page = page
      this.getDevelopment()
    },

    // 跳转详情页
    goDetail (path, item) {
      sessionStorage.setItem('detailData', JSON.stringify(item))
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="less">
.development{
  width: 100%;
  min-height: 90vh;
  font-size: 16px;
  background-color: #F5F5F5;
  margin-top: 8px;
  overflow: hidden;
}
.league-layout{
  display: flex;
  width: 1200px;
  min-height: 790px;
  margin: 0 auto;
}
.league-development{
  width: 940px;
  min-height: 790px;
  margin: 20px auto 100px;
  background-color: #fff;
  border-radius: 2px;
  padding: 0 30px;
  overflow: hidden;
  h3{
    font-size: 20px;
    font-weight: 400;
    margin-top: 30px;
    padding-left: 15px;
    border-left: 4px solid #3056D9;
    border-radius: 2px 0 0 2px;
  }
  .Con-development{
      .development-tit{
          font-size: 22px;
          font-weight: 600;
          text-align: center;
          margin: 32px 0;
      }
      .development-art{
          display: flex;
          margin-top: 10px;
          box-sizing: border-box;
          border: 1px solid #EFEEEE;
          cursor: pointer;
          img{
              // width: 192px;
              // height: 137px;
              width: 280px;
              height: 180px;
              margin: 10px 12px;
              cursor: pointer;
          }
          .deed{
              width:705px ;
              margin: 15px 16px 10px 0;
            .title{
                font-size: 16px;
                font-family: "Microsoft YaHei";
                color: #252728;
            }
            .time,
            .reader,
            .content{
                font-size: 14px;
                color: #8F9096;
                margin-top: 5px;
                line-height: 1.5;
            }
            .reader{
                img{
                    width: 11px;
                    height: 7px;
                    vertical-align: middle;
                    margin-right: 5px;
                }
            }
            // .content{
            //     overflow: hidden;
            //     display: -webkit-box;
            //     -webkit-line-clamp: 2; //显示行数
            //     -webkit-box-orient: vertical;
            // }
          }
      }
  }
}
</style>
